import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getContentHeightString, PagePadding } from '../../styles/layoutDimensions';

function Page({ dusk, fixedHeight = true, children }) {
  const { path } = useRouteMatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  const heightProps = {
    ...(fixedHeight && {
      height: getContentHeightString(),
      overflowY: 'auto'
    }),
    ...(!fixedHeight && {
      minHeight: getContentHeightString(),
      height: '100%'
    })
  };

  return (
    <Box
      bg="background.main"
      dusk={dusk}
      minWidth="1040px"
      {...heightProps}
      padding={PagePadding}
      width="100%"
    >
      {children}
    </Box>
  );
}

Page.propTypes = {
  fixedHeight: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

export default Page;
